




import { Component, Vue } from 'vue-property-decorator';
import SellingCoinsCampaignCreationPage from '@/views/SellCoins/Campaign/SellingCoinsCampaignCreation.vue';

@Component({
  components: {
    SellingCoinsCampaignCreationPage
  }
})
export default class SellCoinsCampaignCreation extends Vue {}
